import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M15.75 7.5H2.25m9.75-6v3m-6-3v3m-.15 12h6.3c1.26 0 1.89 0 2.371-.245a2.25 2.25 0 0 0 .984-.983c.245-.482.245-1.112.245-2.372V6.6c0-1.26 0-1.89-.245-2.371a2.25 2.25 0 0 0-.984-.984C14.042 3 13.412 3 12.15 3h-6.3c-1.26 0-1.89 0-2.371.245a2.25 2.25 0 0 0-.984.984c-.245.48-.245 1.11-.245 2.371v6.3c0 1.26 0 1.89.245 2.371.216.424.56.768.984.984.48.245 1.11.245 2.371.245"
    }, null, -1)
  ])))
}
export default { render: render }